module.exports = __webpack_public_path__ + "img/dataStructures.a00cb72d.svg";